import * as React from 'react'
import { SVGProps } from 'react'

const SvgPulseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 22' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M19 0H5a5.006 5.006 0 0 0-5 5v8a5.006 5.006 0 0 0 5 5h6v2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-4v-2h6a5.006 5.006 0 0 0 5-5V5a5.006 5.006 0 0 0-5-5Zm0 10h-2.965l-1.7 2.555A1 1 0 0 1 13.5 13h-.062a1 1 0 0 1-.833-.551l-2.229-4.461-1.044 1.567A1 1 0 0 1 8.5 10H5a1 1 0 0 1 0-2h2.965l1.7-2.555A.987.987 0 0 1 10.562 5a1 1 0 0 1 .833.551l2.229 4.459 1.044-1.567A1 1 0 0 1 15.5 8H19a1 1 0 1 1 0 2Z'
      fill='#fff'
    />
  </svg>
)

export default SvgPulseIcon
